import axios from "axios";
export const APIURL = process.env.REACT_APP_API_ENDPOINT;
export const DEVICE_URL  = APIURL+"/sensor";
export const APPROVAL_URL  = APIURL+"/approval";

// CREATE =>  POST: add a new customer to the server
export function createCustomer(customer) {
  return axios.post(DEVICE_URL, { customer });
}

// READ
export function getAllCustomers() {
  return axios.get(DEVICE_URL);
}

export function getCustomerById(customerId) {
  return axios.get(`${DEVICE_URL}/${customerId}`);
}

// Method from server should return QueryResultsModel(items: any[], totalsCount: number)
// items => filtered/sorted result
export function findCustomers() {
  return axios.get(`${DEVICE_URL}`);
}

// UPDATE => PUT: update the customer on the server
export function updateCustomer(customer) {
  return axios.put(`${DEVICE_URL}/${customer.id}`, { customer });
}

// UPDATE => PUT: update the device on the server
export function updateDevice(id, params) {
  return axios.put(`${DEVICE_URL}/${id}`, params);
}

// CREATE => POST: create the device on the server
export function createDevice(params) {
  return axios.post(DEVICE_URL, params);
}

// UPDATE Status
export function updateStatusForCustomers(ids, status) {
  return axios.post(`${DEVICE_URL}/updateStatusForCustomers`, {
    ids,
    status
  });
}

// DELETE => delete the customer from the server
export function deleteCustomer(customerId) {
  return axios.delete(`${DEVICE_URL}/${customerId}`);
}

// DELETE Customers by ids
export function deleteCustomers(ids) {
  return axios.post(`${DEVICE_URL}/deleteCustomers`, { ids });
}

// Send Request
export function approvalRequest(params) {
  return axios.post(APPROVAL_URL, params);
}
// fetch all Requests
export function getApprovalRequest(startDate,endDate) {
  return axios.get(APPROVAL_URL+"?start="+startDate+"&end="+endDate);
  //return axios.get(APPROVAL_URL);
}

// fetch all Requests
export function ApproveRequests(id,params) {
  return axios.put(`${APPROVAL_URL}/${id}`,params);
}

// fetch all Requests
export function exportDeviceData(id,sensor_id) {	
	axios({url:`${DEVICE_URL}/download_sensor_control`,
			method: 'post',
			data:{id,sensor_id},
			responseType: 'blob', // important
		}).then((response) => {
			const url = window.URL.createObjectURL(new Blob([response.data]));
			const link = document.createElement('a');
			link.href = url;
			link.setAttribute('download', 'device_control_variables.csv');
			document.body.appendChild(link);
			link.click();
		});
}

// fetch all Requests
export function exportRequestData(startDate,endDate) {	
	axios({url:APPROVAL_URL+"/exportcsv?start="+startDate+"&end="+endDate,
			method: 'get',
			responseType: 'blob', // important
		}).then((response) => {
			const url = window.URL.createObjectURL(new Blob([response.data]));
			const link = document.createElement('a');
			link.href = url;
			link.setAttribute('download', 'device_control_variables.csv');
			document.body.appendChild(link);
			link.click();
		});
}
